import { UmOption } from './option.js';

export type ExtendedOption = HTMLOptionElement & { _parent: UmOption };
